import PropTypes from 'prop-types';


// ------ currencies
export const CURRENCY_EUR = {
    code: 'EUR',
    name: 'Euro',
    symbol: '€'
};

export const CURRENCIES = [
    CURRENCY_EUR
];


export const CURRENCY_BY_CODE = {};
CURRENCIES.forEach(currency => {
    CURRENCY_BY_CODE[currency.code] = currency;
});


// ------ shapes
export const SHAPE_CURRENCY = {
    code: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    symbol: PropTypes.string.isRequired
};


export const SHAPE_PRICE = {
    currency: PropTypes.shape(SHAPE_CURRENCY).isRequired,
    doShowCurrencySymbol: PropTypes.bool,
    value: PropTypes.number.isRequired
};
